import {
  BASE_URL,
  CANONICAL_BASE_URL,
  buildPublicUrl,
  normalizePublicDataUrls,
  normalizePublicUrl,
  redirectCustomDomainToCanonical,
} from "./baseUrl";

export const PRIMARY_APP_ORIGIN = BASE_URL;
export const FALLBACK_APP_ORIGIN = CANONICAL_BASE_URL;
export const LEGACY_RCCG_ORIGIN = "https://church-fundraising-rccg.web.app";

export const ALLOWED_APP_ORIGINS = new Set([
  "https://lightly.web.app",
  "https://church-fundraising-rccg.web.app",
  "http://localhost:3000",
  "http://localhost:5173",
]);

export function getCurrentOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return PRIMARY_APP_ORIGIN;
}

export function getAppOrigin(locationLike = typeof window !== "undefined" ? window.location : null) {
  const configured = String(process.env.REACT_APP_PUBLIC_BASE_URL || "").trim().replace(/\/+$/, "");
  if (configured) return configured;

  const currentOrigin = String(locationLike?.origin || "").replace(/\/+$/, "");
  const hostname = String(locationLike?.hostname || "").toLowerCase();
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return currentOrigin || CANONICAL_BASE_URL;
  }

  return CANONICAL_BASE_URL;
}

export function getCanonicalAppOrigin() {
  return BASE_URL.replace(/\/+$/, "");
}

export function buildAuthActionUrl(locationLike) {
  return `${getAppOrigin(locationLike)}/auth/action`;
}

export function buildOrgUrl(orgSlug, path = "") {
  const cleanSlug = String(orgSlug || "").replace(/^\/+|\/+$/g, "");
  const cleanPath = String(path || "").replace(/^\/+/, "");
  return buildPublicUrl(`${cleanSlug}${cleanPath ? `/${cleanPath}` : ""}`);
}

export function buildPlatformUrl(path = "") {
  return buildPublicUrl(path);
}

export function redirectWwwToPrimary(locationLike = window.location) {
  return redirectCustomDomainToCanonical(locationLike);
}

export {
  buildPublicUrl,
  normalizePublicDataUrls,
  normalizePublicUrl,
  redirectCustomDomainToCanonical,
};
